import {
	connect
} from 'react-redux'
import SimpleDataTable from '../components/common/SimpleDataTable.jsx';
import {
	findFittingDashboard
} from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['fittingReducer', 'statOverviewCount']),
	fields: {
		gear_display: '項目',
		quantity: '總件數',
		cnt: '已套量件數',
	},
    keys: ['order_detail_id'],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: () => {
		if (ownProps.orderId) {
			dispatch(findFittingDashboard({orderId:ownProps.orderId}));			
		}
	}
})

const FittingStatOverviewCountContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SimpleDataTable)

export default FittingStatOverviewCountContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingStatOverviewCountContainer.jsx